export function channel() {
  const q = new URLSearchParams(window.location.search);
  return q.get("utm_source") === "google"
    ? "gbp"
    : q.get("utm_source") === "blog" || document.referrer.includes("/blog/")
      ? "blog"
      : document.referrer.includes("google.")
        ? "organic"
        : "direct";
}
export function event(name) {
  fetch("/api/eventos", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, channel: channel() }),
    keepalive: true,
  }).catch(() => {});
}
